const digitalData = { //Empty object created at each page load (dev involvement needed)
    "qualifyForInternet": {},
    "saveCart": {},
    "visitorProfile": {}, 
    "pageInfo": {}, 
    "campaignInfo": {},
    "errors":[], 
    "searches":[], 
    "productsDisplayed":[], 
    "shoppingCartInfo":{}, //Set or update this object immediately after a cart add, Remove, Update  
    "transactionInfo":{}, //Set this object only on cart confirmation page
    "events": [] ,
    "qualifiedServices": []
};//end digitalData (empty)

export default digitalData;


// export const cartInfo = {
//     "planDetails": {
//         "headerInfoList":{
//             "Price": "224.00",
//             "Title": "Verizon Triple Play (Phone + Internet + TV)",
//             "isStandalone": false,
//             "contract":"TwoYears",
//             "selectedService":"BDV",
//             "PartialTotal": "13.43",
//             "TotalFirstMonthPrice":"303.43",
//             "fbilltax": "31.30",
//             "hasTechProOffer": "N"
//         },
//         "dataInfoList":{
//             "planName": "Fios Internet 200 Mbps - Dynamic",
//             "planPrice":"$110"
//         },
//         "phoneInfoList":{
//             "noOfLines":3,
//             "planPrice":"$110",
//             "planName":"Standard Phone",
//             "phoneTitle": "Two Business Digital Voice(s) ",
//            "lines":[
//             {
//               "planName": "Verizon Solutions for Business 2 Yr term with CustoPAK®",
//               "total": 0,
//               "TN": "2129273651",
//               "Chagres": []
//             },
//             {
//               "planName": "Additional Bundle Line Plus with CustoPAK®",
//               "total": 0,
//               "TN": "2129273652",
//               "Chagres": []
//             },
//             {
//               "planName": "Additional Bundle Line",
//               "total": 0,
//               "TN": "2129273653",
//               "Chagres": []
//             }
//           ],
//           "phoneServices":[
//             {
//               "Name": "Non Published & Non Listed",
//               "Rc": "$4.50"
//             },
//             {
//               "Name": "FirmRate Advantage",
//               "Rc": "$10.00"
//             }
//           ],
//           "subTotalPhoneService":"$5.00",
//           "FaxLine": [
//             {
//               "prdName": "Measured Rate Local Calling Service - 24 Month Term",
//               "keyWord": "2129270463",
//               "Price": "$19.35",
//               "WMName": "No Maintenance Plan",
//               "WMPrice": "0",
//               "isRouterDisc": false
//             }
//           ]
//         },
//         "tvInfoList":{
//             "planName": "Local TV",
//             "planPrice":"$110",
//             "tvServices": [
//                 {
//                   "prdName": "Spanish Language",
//                   "keyWord": "|INTERNATIONAL|",
//                   "Price": "$16.00",
//                   "WMName": null,
//                   "WMPrice": null,
//                   "isRouterDisc": false
//                 },
//                 {
//                   "prdName": "Fios Korean",
//                   "keyWord": "",
//                   "Price": "$24.99",
//                   "WMName": null,
//                   "WMPrice": null,
//                   "isRouterDisc": false
//                 },
//                 {
//                   "prdName": "STARZ",
//                   "keyWord": "|COMPNAME:STARZ|HIDEFORIOSC:Q2512|PREMPACK:NOTLEGACY|SUPPRESSIF:LEGACYPREM|USEWITH:PREMIUMPACK|",
//                   "Price": "Included",
//                   "WMName": null,
//                   "WMPrice": null,
//                   "isRouterDisc": false
//                 },
//                 {
//                   "prdName": "HBOmax",
//                   "keyWord": "|COMPNAME:HBO|PREMPACK:NOTLEGACY|SUPPRESSIF:LEGACYPREM|USEWITH:PREMIUMPACK|",
//                   "Price": "Included",
//                   "WMName": null,
//                   "WMPrice": null,
//                   "isRouterDisc": false
//                 },
//                 {
//                   "prdName": "CableCARD(1)",
//                   "keyWord": null,
//                   "Price": "$4.99",
//                   "WMName": null,
//                   "WMPrice": null,
//                   "isRouterDisc": false
//                 },
//                 {
//                   "prdName": "Basic Digital Adapter(1)",
//                   "keyWord": null,
//                   "Price": "$8.00",
//                   "WMName": null,
//                   "WMPrice": null,
//                   "isRouterDisc": false
//                 },
//                 {
//                   "prdName": "HD Set-Top Box(1)",
//                   "keyWord": null,
//                   "Price": "$11.99",
//                   "WMName": null,
//                   "WMPrice": null,
//                   "isRouterDisc": false
//                 },
//                 {
//                   "prdName": "Multi-Room DVR service(1)",
//                   "keyWord": null,
//                   "Price": "$15.00",
//                   "WMName": null,
//                   "WMPrice": null,
//                   "isRouterDisc": false
//                 }
//               ],
//               "movieChannelsPack" : [
//                 {
//                 "channelName": "Multi-Room DVR service(1)"
//                },
//               {
//                 "channelName": "Multi-Room DVR service(1)"
//               },
//               {
//                 "channelName": "Multi-Room DVR service(1)"
//               }
//             ],
//               "movieChannelsPackPrice":"$30.00",
//               "subTotalTvServices":"$105.97"
//         },
//         "otherServices":[
//            {"Product": "Self Installation", "price": "$0.00"},
//             {"Product": "Tech Support Pro","price": "Included"},
//             {"Product": "Service Protection Plan", "price": "$11.99"}          
//         ],
//         "subTotals":{
//            "services": "$128.50",
//            "otherServices": "$224.00"
//         }
//     },
//     "equipmentAndOnetimeCharges":{
//         "products":[
//             {
//               "offerName": "Purchase Fios business router",
//               "wavied": false,
//               "price": "$199.99",
//               "type": "NONBDV"
//             },
//             {
//               "offerName": "Wireless Modem/Router",
//               "wavied": false,
//               "price": "$24.99",
//               "type": "NONBDV"
//             },
//             {
//               "offerName": "Basic Internet Activation",
//               "wavied": false,
//               "price": "$24.99",
//               "type": "NONBDV"
//             },

//             {
//               "offerName": "Fios TV Activation Fee",
//               "wavied": true,
//               "type": "NONBDV",
//               "price": "Fee Waived"
//             },
//             {
//               "offerName": "MLB Extra Innings Regular Season",
//               "wavied": false,
//               "price": "$110",
//               "type": "NONBDV"
//             },
//             {
//               "offerName": "Existing TV Outlet (up to 3)(1)",
//               "wavied": true,
//               "type": "NONBDV",
//               "price": "Fee Waived"
//             },
//             {
//               "offerName": "3-line phone(1) = $85, Installment 1 of 12",
//               "wavied": false,
//               "type": "NONBDV",
//               "price": "$69.98"
//             },
//             {
//                 "offerName": "3-line phone(1)",
//                 "wavied": false,
//                 "type": "BDV",
//                 "price": "$85"
//               },
//               {
//                 "offerName": "12-line phone(1)",
//                 "wavied": false,
//                 "type": "BDV",
//                 "price": "$150"
//               },
//               {
//                 "offerName": "2-port analog converter(1)",
//                 "wavied": false,
//                 "type": "BDV",
//                 "price": "$85"
//               },
//               {
//                 "offerName": "4-port analog converter(1)",
//                 "wavied": false,
//                 "type": "BDV",
//                 "price": "$130"
//               },
//               {
//                 "offerName": "8-line cordless phone with base(1)",
//                 "wavied": false,
//                 "type": "BDV",
//                 "price": "$150"
//               },
//               {
//                 "offerName": "Additional cordless handset(1)",
//                 "wavied": false,
//                 "type": "BDV",
//                 "price": "$85"
//               },
//               {
//                 "offerName": "Business Digital Voice Shipping(6)",
//                 "wavied": false,
//                 "type": "NONBDV",
//                 "price": "$0.00"
//               }
//           ],

//           "subTotalequipmentAndOnetimeCharges":"$126.69"
//     },
//     "firstMonthServiceCharges" :{
//       "products" : [
//       {
//         "offerName": "Wireless Modem/Router = $24.99, Installment 1 of 2",
//         "wavied": false,
//         "IsBdvEquip": false,
//         "price": "12.49"
//       },
//       {
//         "offerName": "Basic Internet Activation = $24.99, Installment 1 of 2",
//         "wavied": false,
//         "IsBdvEquip": false,
//         "price": "12.49"
//       }
//     ],
//     "subTotalOnetimeCharges":"$24.98"
//     },
//    "taxAndotherChargespro": {
//         "offerName": "Fios Activation Fee",
//         "wavied": true,
//         "price": 0,
//         "type": "NONBDV"
//       }
//     ,
//     "taxAndOtherCharges":{
//         "taxCharges": 0,
//         "subTotalTaxCharges": 0
//       }

// };

 